import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  AbstractControl,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ApiNewDokumentPowiazanyDalDto,
  ColumnHeader,
  DepartmentCode,
  DocFile,
  DocSignService,
  EgibObject,
  FormAlertService,
  MapAction,
  MapId,
  MapObject,
  MapObjectApiType,
  MapObjectTableActionType,
  MapObjectTableState,
  MapPortalName,
  MapSettings,
  MapSettingsService,
  MapState,
  MapStateService,
  PzService,
  ShippingFormName,
  ToolType,
  defaultMapGeometryStyles,
  docFileToDtoDocument,
  initialToolsStateWithButtonText,
} from '@gk/gk-modules';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import {
  EMPTY,
  Observable,
  Subject,
  catchError,
  debounceTime,
  distinctUntilChanged,
  filter,
  switchMap,
  takeWhile,
  tap,
} from 'rxjs';
import { MainRoutes } from '../../../guards/guard.models';
import { AuthorizedPersonControlName } from '../../../services/authorized-person-form/authorized-person-form.model';
import { FormsStateService } from '../../../services/forms-state/forms-state.service';
import { NewRequestHelperService } from '../../../services/new-request-helper/new-request-helper.service';
import { BsMessageType } from '../../../services/request-workspace-state/request-workspace-state.model';
import { SettingsService } from '../../../services/settings/settings.service';
import { BaseNewRequestComponent } from '../../../shared/base-new-request/base-new-request.component';
import {
  FeeWaiverCause,
  FeeWaiverControlName,
  FeeWaiverForm,
} from '../../../shared/fee-waiver/fee-waiver.model';
import {
  Shipping,
  ShippingFormControlName,
} from '../../../shared/shipping-form/shipping-form.model';
import { PlanningDepartmentConfigService } from '../planning-department-config.service';
import { ExtractCertificateFeeResponse } from '../services/extract-certificate-fee/extract-certificate-fee.model';
import { ExtractCertificateFeeService } from '../services/extract-certificate-fee/extract-certificate-fee.service';
import { ECNewRequestFormControlName } from '../services/new-request-form/new-request-form.model';
import { ECNewRequestFormService } from '../services/new-request-form/new-request-form.service';
import { ECNewRequest } from '../services/new-request/new-request.model';
import { PlanningDepartmentDocTypeId } from '../shared/planning-department-doc-type.model';
import { PlanningDepartmentRequestType } from '../shared/planning-department.model';
import { AppTitleService } from './../../../services/app-title/app-title.service';

@Component({
  selector: 'app-extract-from-local-spatial-development-plan-request',
  templateUrl:
    './extract-certificate-from-local-spatial-development-plan-or-study-request.component.html',
  styles: [],
  standalone: false,
})
export class ExtractCertificateFromLocalSpatialDevelopmentPlanOrStudyRequestComponent
  extends BaseNewRequestComponent
  implements OnInit, OnDestroy
{
  override isAlive = true;
  override mapState = MapState.getInitialStruct();
  override initialToolsState = _.cloneDeep(initialToolsStateWithButtonText);
  override defaultMapGeometryStyles = _.cloneDeep(defaultMapGeometryStyles);
  override formGroup: UntypedFormGroup;
  override submitted = false;
  override controlName = ECNewRequestFormControlName;
  formNotValidTranslation: string;
  requestSuccessfullySigned = true;
  planningDepartmentDocTypeId = PlanningDepartmentDocTypeId;
  chosenFiles: { [key in PlanningDepartmentDocTypeId]?: File[] } = {};
  planningDepartmentRequestTypeEnum = PlanningDepartmentRequestType;
  requestFormType: PlanningDepartmentRequestType;
  calculatedPrice = 0;
  calculatedPriceErrorOccurred = false;
  calculatedPricePending = false;
  calculatedPriceResponseStatus: string;
  calculatedPriceErrorResponseStatus: string;
  calculatePayment$: Subject<void> = new Subject();
  customApplicantPostOfficeModalHeaderInfoTranslation: string;
  customShippingFormPostOfficeModalHeaderInfoTranslation: string;
  quantityFormControlShouldBeReadonly: boolean;
  departmentCode = DepartmentCode;

  constructor(
    private toastr: ToastrService,
    private appTitleService: AppTitleService,
    protected override pzService: PzService,
    protected override newRequestHelperService: NewRequestHelperService,
    protected override docSignService: DocSignService,
    protected override translateService: TranslateService,
    protected override mapSettingsService: MapSettingsService,
    protected override mapStateService: MapStateService,
    protected override formAlertService: FormAlertService,
    public route: ActivatedRoute,
    public extractCertificateFeeService: ExtractCertificateFeeService,
    public formsStateService: FormsStateService,
    public override router: Router,
    public ecNewRequestFormService: ECNewRequestFormService,
    public settingsService: SettingsService,
    public planningDepartmentConfigService: PlanningDepartmentConfigService,
  ) {
    super(
      pzService,
      newRequestHelperService,
      docSignService,
      router,
      translateService,
      mapSettingsService,
      mapStateService,
      formAlertService,
    );
  }

  override ngOnInit(): void {
    this.setPortalId();
    this.createForm();
    this.setTypeOfRequest();
    this.setFormSubjectForCertificateFromSpatialDevelopmentPlan();
    this.subscribeToShippingFormControlValueChanges();
    this.subscribeToQuantityFormControlValueChanges();
    this.subscribeToSubjectFormGroupValueChanges();
    this.subscribeToFeeWaiverFormGroupValueChanges();
    super.subscribeToDocSignTranslations();
    this.subscribeToFormNotValidTranslation();
    this.subscribeToApplicantDetailsCustomPostOfficeModalHeaderInfoTranslation();
    this.subscribeToShippingFormCustomPostOfficeModalHeaderInfoTranslation();
    this.subscribeToMapSettings();
    this.subscribeToCalculatePayment();
    this.fetchWrongFileText();
  }

  setPortalId(): void {
    this.appTitleService.currentWebPortal
      .pipe(takeWhile(() => this.isAlive))
      .subscribe((webPortal) => {
        this.portalId = webPortal.portalId;
      });
  }

  createForm(): void {
    this.formGroup = this.ecNewRequestFormService.getFormGroup();
  }

  setTypeOfRequest(): void {
    if (
      this.router.url.includes(
        MainRoutes.PlanningDepartmentExtractFromLocalSpatialDevelopmentPlan,
      )
    ) {
      this.requestFormType =
        PlanningDepartmentRequestType.ExtractFromLocalSpatialDevelopmentPlan;
    } else if (
      this.router.url.includes(MainRoutes.PlanningDepartmentExtractFromStudy)
    ) {
      this.requestFormType = PlanningDepartmentRequestType.ExtractFromStudy;
    } else {
      this.requestFormType = PlanningDepartmentRequestType.Certificate;
    }
  }

  setFormSubjectForCertificateFromSpatialDevelopmentPlan(): void {
    if (
      this.router.url.includes(
        MainRoutes.PlanningDepartmentCertificateFromLocalSpatialDevelopmentPlan,
      )
    ) {
      this.getSubjectFormGroup().patchValue({
        [ECNewRequestFormControlName.WrittenExtractCheckbox]: false,
        [ECNewRequestFormControlName.GraphicExtractCheckbox]: false,
        [ECNewRequestFormControlName.CertificateCheckbox]: true,
      });
    }
  }

  subscribeToShippingFormControlValueChanges(): void {
    this.getShippingFormTypeRadioFormControl()
      .valueChanges.pipe(takeWhile(() => this.isAlive))
      .subscribe((value) => {
        if (value.emailRequired) {
          this.getQuantityFormControl().setValue(1);
        }
        if (value.name === ShippingFormName.SelfPickup) {
          this.quantityFormControlShouldBeReadonly = false;
          this.getAuthorizedDetailsCheckboxFormControl().enable();
        } else {
          this.quantityFormControlShouldBeReadonly = true;
          this.getQuantityFormControl().setValue(1);
          this.getAuthorizedDetailsCheckboxFormControl().disable();
          this.getAuthorizedDetailsCheckboxFormControl().reset();
        }
        this.maybeTriggerCalculatePayment();
      });
  }

  subscribeToQuantityFormControlValueChanges(): void {
    this.getQuantityFormControl()
      .valueChanges.pipe(
        takeWhile(() => this.isAlive),
        distinctUntilChanged(),
      )
      .subscribe(() => this.maybeTriggerCalculatePayment());
  }

  subscribeToSubjectFormGroupValueChanges(): void {
    this.getSubjectFormGroup()
      .valueChanges.pipe(
        takeWhile(() => this.isAlive),
        distinctUntilChanged(),
      )
      .subscribe(() => this.maybeTriggerCalculatePayment());
  }

  subscribeToFeeWaiverFormGroupValueChanges(): void {
    this.getFeeWaiverFormGroup()
      .valueChanges.pipe(
        takeWhile(() => this.isAlive),
        distinctUntilChanged(),
      )
      .subscribe(() => {
        this.maybeTriggerCalculatePayment();
        this.maybeDisableDismissalReasonExplanationDescriptionFormControl();
      });
  }

  maybeDisableDismissalReasonExplanationDescriptionFormControl(): void {
    const dismissalReasonExplanationDescriptionFormControl =
      this.getDismissalReasonExplanationDescriptionFormControl();
    if (this.isDismissalReasonExplanationVisible()) {
      dismissalReasonExplanationDescriptionFormControl.enable();
    } else {
      dismissalReasonExplanationDescriptionFormControl.disable();
    }
  }

  subscribeToFormNotValidTranslation(): void {
    this.translateService
      .get('PLANNING_DEPARTMENT.VALIDATION.FORM_NOT_VALID_ERROR')
      .pipe(takeWhile(() => this.isAlive))
      .subscribe(
        (formNotValidTranslation) =>
          (this.formNotValidTranslation = formNotValidTranslation),
      );
  }

  subscribeToApplicantDetailsCustomPostOfficeModalHeaderInfoTranslation(): void {
    this.translateService
      .get(
        'PLANNING_DEPARTMENT.EXTRACT_CERTIFICATE_FROM_LOCAL_SPATIAL_DEVELOPMENT_PLAN_OR_STUDY_REQUEST.SECTIONS.APPLICANT_DETAILS.CUSTOM_POST_OFFICE_MODAL_HEADER_INFO',
      )
      .pipe(takeWhile(() => this.isAlive))
      .subscribe(
        (customApplicantPostOfficeModalHeaderInfoTranslation) =>
          (this.customApplicantPostOfficeModalHeaderInfoTranslation =
            customApplicantPostOfficeModalHeaderInfoTranslation),
      );
  }

  subscribeToShippingFormCustomPostOfficeModalHeaderInfoTranslation(): void {
    this.translateService
      .get('SHIPPING_CUSTOM_POST_OFFICE_MODAL_HEADER_INFO')
      .pipe(takeWhile(() => this.isAlive))
      .subscribe(
        (customShippingFormPostOfficeModalHeaderInfoTranslation) =>
          (this.customShippingFormPostOfficeModalHeaderInfoTranslation =
            customShippingFormPostOfficeModalHeaderInfoTranslation),
      );
  }

  subscribeToMapSettings(): void {
    this.mapSettingsService
      .getMapSettings(MapPortalName.Planning)
      .pipe(takeWhile(() => this.isAlive))
      .subscribe((planningMapSettings) =>
        this.setMapState(planningMapSettings),
      );
  }

  subscribeToCalculatePayment(): void {
    this.calculatePayment$
      .pipe(
        tap(() => this.resetPaymentStatusViewData()),
        debounceTime(500),
        filter(() => this.isRequestForCalculatePaymentValid()),
        tap(() => (this.calculatedPricePending = true)),
        switchMap(() =>
          this.extractCertificateFeeService
            .calculatePayment(this.getFormValue(), this.getParcelsMapObjects())
            .pipe(
              catchError((err) =>
                this.handleCalculatePaymentErrorResponse(err),
              ),
            ),
        ),
      )
      .subscribe((response) =>
        this.handleCalculatePaymentSuccessResponse(
          response as ExtractCertificateFeeResponse,
        ),
      );
  }

  resetPaymentStatusViewData(): void {
    this.calculatedPrice = 0;
    this.calculatedPriceErrorOccurred = false;
    this.calculatedPriceResponseStatus = '';
  }

  handleCalculatePaymentErrorResponse(err: HttpErrorResponse): Observable<any> {
    this.calculatedPriceErrorResponseStatus =
      this.getResponseStatusMessage(err);
    this.calculatedPrice = 0;
    this.calculatedPriceErrorOccurred = true;
    this.calculatedPricePending = false;

    return EMPTY;
  }

  handleCalculatePaymentSuccessResponse(
    response: ExtractCertificateFeeResponse,
  ): void {
    this.calculatedPrice = response.amount;
    this.calculatedPriceResponseStatus = response.status;
    this.calculatedPriceErrorOccurred = false;
    this.calculatedPricePending = false;
  }

  override setMapState(mapSettings: MapSettings): void {
    this.mapState = new MapState(
      MapId.PlanningDepartmentExtractFromLocalSpatialDevelopmentPlan,
      this.mapStateService.getViewState(
        MapId.PlanningDepartmentExtractFromLocalSpatialDevelopmentPlan,
        mapSettings,
      ),
      this.mapStateService.getToolbarState(
        [ToolType.LandParcel],
        mapSettings.papers,
        undefined,
        undefined,
        true,
      ),
      this.initialToolsState,
      this.mapStateService.getLayersState(
        MapId.PlanningDepartmentExtractFromLocalSpatialDevelopmentPlan,
        mapSettings,
        MapPortalName.Planning,
      ),
      [
        new MapObjectTableState(
          [
            new ColumnHeader(
              'mapObjectNumber',
              'PARCEL_SEARCH_FORM.PARCEL_NUMBER',
            ),
            new ColumnHeader('districtName', 'PARCEL_SEARCH_FORM.DISTRICT'),
            new ColumnHeader('mapSheet', 'PARCEL_SEARCH_FORM.SHEET'),
          ],
          undefined,
          this.defaultMapGeometryStyles,
          true,
          false,
          true,
          '25',
          this.formsStateService.newDesignerRequestChosenParcels,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          [MapObjectApiType.LandParcel],
          true,
        ),
      ],
    );
  }

  override handleMapAction(mapAction: MapAction): void {
    this.mapState = this.mapStateService.getUpdatedMapState(
      mapAction,
      this.mapState,
    );
    if (
      mapAction.type === MapObjectTableActionType.AddToExisting ||
      mapAction.type === MapObjectTableActionType.Remove ||
      mapAction.type === MapObjectTableActionType.RemoveAll
    ) {
      this.maybeTriggerCalculatePayment();
    }
  }

  maybeTriggerCalculatePayment(): void {
    this.calculatePayment$.next();
  }

  getResponseStatusMessage(error: HttpErrorResponse): string {
    return _.get(error, 'error.ResponseStatus.Message', '');
  }

  async handleSubmit(): Promise<void> {
    this.submitted = true;
    if (!this.isRequestValid()) {
      this.toastr.error(this.formNotValidTranslation);
      return;
    }

    const apiFiles = await Promise.all(this.getConvertedFiles()).catch(
      () => new Error(),
    );
    if (
      (Array.isArray(apiFiles) &&
        apiFiles.some((file) => file instanceof Error)) ||
      apiFiles instanceof Error
    ) {
      this.toastr.error(this.wrongFilesErrorText);

      return;
    }

    this.sendRequest(apiFiles as ApiNewDokumentPowiazanyDalDto[]);
  }

  getConvertedFiles(): Promise<ApiNewDokumentPowiazanyDalDto | Error>[] {
    return this.getChosenFiles().map((docFile) =>
      docFileToDtoDocument(docFile),
    );
  }

  getChosenFiles(): DocFile[] {
    return [].concat(...Object.values(this.chosenFiles));
  }

  isRequestForCalculatePaymentValid(): boolean {
    return (
      this.getSubjectFormGroup().valid &&
      this.areParcelsChosen() &&
      this.getQuantityFormControl().valid
    );
  }

  isRequestValid(): boolean {
    return (
      this.formGroup.valid &&
      this.areParcelsChosen() &&
      this.checkAttachmentsShouldNotBeValidated() &&
      this.isCalculatedPaymentValid()
    );
  }

  checkParcelsNotChosenAndFormSubmitted(): boolean {
    return !this.areParcelsChosen() && this.submitted;
  }

  areParcelsChosen(): boolean {
    return this.mapState.mapObjectTablesState[0].mapObjects.some(
      (mapObject) => mapObject.type === MapObjectApiType.LandParcel,
    );
  }

  checkAttachmentsShouldNotBeValidated(): boolean {
    const feeWaiverFormGroupValue = this.getFeeWaiverFormGroupValue();

    if (!feeWaiverFormGroupValue.feeWaiverCheckbox) {
      return true;
    }

    switch (feeWaiverFormGroupValue.feeWaiverCause) {
      case FeeWaiverCause.SocialAssistanceBecauseOfPoverty:
        return !!this.chosenFiles[
          PlanningDepartmentDocTypeId.SocialWelfareCertificate
        ];
      case FeeWaiverCause.Other:
        return !!this.chosenFiles[
          PlanningDepartmentDocTypeId.DismissalReasonExplanation
        ];
      default:
        return true;
    }
  }

  isCalculatedPaymentInValidAndFormSubmitted(): boolean {
    return !this.isCalculatedPaymentValid() && this.submitted;
  }

  isCalculatedPaymentValid(): boolean {
    return !this.calculatedPriceErrorOccurred;
  }

  isSocialWelfareCertificateRequiredAndFormSubmitted(): boolean {
    const feeWaiverFormGroupValue = this.getFeeWaiverFormGroupValue();

    return (
      feeWaiverFormGroupValue.feeWaiverCheckbox &&
      !this.chosenFiles[PlanningDepartmentDocTypeId.SocialWelfareCertificate] &&
      this.submitted
    );
  }

  isDismissalReasonExplanationRequiredAndFormSubmitted(): boolean {
    const feeWaiverFormGroupValue = this.getFeeWaiverFormGroupValue();
    const dismissalReasonExplanationDescriptionFormControl =
      this.getDismissalReasonExplanationDescriptionFormControl();

    return (
      this.submitted &&
      ((feeWaiverFormGroupValue.feeWaiverCheckbox &&
        !this.chosenFiles[
          PlanningDepartmentDocTypeId.DismissalReasonExplanation
        ]) ||
        dismissalReasonExplanationDescriptionFormControl.invalid)
    );
  }

  sendRequest(apiDocuments: ApiNewDokumentPowiazanyDalDto[]): void {
    this.docSignPending = true;
    this.setDocSignMsg(BsMessageType.Info, 'SENDING_REQUEST');

    this.docSignService
      .addToSign(
        ECNewRequest.fromAppToApi(
          this.getFormValue(),
          this.getParcelsMapObjects(),
          apiDocuments,
        ),
        this.getAddToSignUrlByRequestFromType(),
      )
      .pipe(takeWhile(() => this.isAlive))
      .subscribe({
        next: (addedDocToSignResponse) => {
          this.handleSendAndValidateSuccess(addedDocToSignResponse);
        },
        error: (err) => {
          console.error(err);
          this.handleSendAndValidateFailure();
        },
      });
  }

  getAddToSignUrlByRequestFromType(): string {
    switch (this.requestFormType) {
      case PlanningDepartmentRequestType.ExtractFromLocalSpatialDevelopmentPlan:
        return '/api/interesant/wniosek/wypisWyrysZPlanuMiejscowego/addToSign';
      case PlanningDepartmentRequestType.Certificate:
        return '/api/interesant/wniosek/zaswiadczenieZPlanuMiejscowego/addToSign';
      case PlanningDepartmentRequestType.ExtractFromStudy:
        return '/api/interesant/wniosek/wypisWyrysZeStudiumUwarunkowan/addToSign';
    }
  }

  getFormValue(): ECNewRequest {
    return {
      ...this.formGroup.value,
      requestFormType: this.requestFormType,
    };
  }

  getParcelsMapObjects(): EgibObject[] {
    return this.mapState.mapObjectTablesState[0].mapObjects.filter(
      <(mapObject: MapObject) => mapObject is EgibObject>(
        ((mapObject) => mapObject.type === MapObjectApiType.LandParcel)
      ),
    );
  }

  override handleDocSignSuccess(): void {
    this.requestSuccessfullySigned = true;
    this.docSignUrl = '';
    this.router.navigate([`../requests-list`], { relativeTo: this.route });
  }

  isShippingFormGroupInvalidAndFormSubmitted(): boolean {
    return this.getShippingFormGroup().invalid && this.submitted;
  }

  isQuantityFormControlInvalidAndFormSubmitted(): boolean {
    return this.getQuantityFormControl().invalid && this.submitted;
  }

  getShippingFormGroupValue(): Shipping {
    return this.getShippingFormGroup().value;
  }

  getAuthorizedDetailsFormGroup(): UntypedFormGroup {
    return this.getFormControlByName(
      AuthorizedPersonControlName.AuthorizedDetailsForm,
    ) as UntypedFormGroup;
  }

  getAuthorizedDetailsCheckboxFormControl(): AbstractControl {
    return this.getAuthorizedDetailsFormGroup().get(
      AuthorizedPersonControlName.AuthorizedDetailsCheckbox,
    );
  }

  getRodoClauseAgreeCheckboxFormControl(): UntypedFormControl {
    return this.getFormControlByName(
      this.controlName.RodoClauseAgreeCheckbox,
    ) as UntypedFormControl;
  }

  getFeeWaiverFormGroup(): UntypedFormGroup {
    return this.getFormControlByName(
      FeeWaiverControlName.FeeWaiverForm,
    ) as UntypedFormGroup;
  }

  getFeeWaiverFormGroupValue(): FeeWaiverForm {
    return this.getFeeWaiverFormGroup().value;
  }

  isSubjectFormGroupInvalidAndFormSubmitted(): boolean {
    return this.getSubjectFormGroup().invalid && this.submitted;
  }

  getSubjectFormGroup(): UntypedFormGroup {
    return this.getFormControlByName(
      this.controlName.Subject,
    ) as UntypedFormGroup;
  }

  isDescriptionFormControlInvalidAndFormSubmitted(): boolean {
    return this.getDescriptionFormControl().invalid && this.submitted;
  }

  getDismissalReasonExplanationDescriptionFormControl(): UntypedFormControl {
    return this.getFormControlByName(
      this.controlName.DismissalReasonExplanationDescription,
    ) as UntypedFormControl;
  }

  getDescriptionFormControl(): UntypedFormControl {
    return this.getFormControlByName(
      this.controlName.Comments,
    ) as UntypedFormControl;
  }

  getQuantityFormControl(): UntypedFormControl {
    return this.getFormControlByName(
      this.controlName.Quantity,
    ) as UntypedFormControl;
  }

  getShippingFormTypeRadioFormControl(): AbstractControl {
    return this.getShippingFormGroup().get(
      ShippingFormControlName.ShippingForm,
    );
  }

  getFormControlByName(formControlName: string): AbstractControl {
    return this.formGroup.get(formControlName);
  }

  shouldShowAtLeastOneRequiredAlert(formControl: AbstractControl): boolean {
    return this.formAlertService.shouldShowErrorAlert(
      formControl,
      'atLeastOneRequired',
      this.submitted,
    );
  }

  isSocialWelfareCertificateVisible(): boolean {
    const feeWaiverFormGroupValue = this.getFeeWaiverFormGroupValue();

    return (
      feeWaiverFormGroupValue.feeWaiverCheckbox &&
      feeWaiverFormGroupValue.feeWaiverCause ===
        FeeWaiverCause.SocialAssistanceBecauseOfPoverty
    );
  }

  isDismissalReasonExplanationVisible(): boolean {
    const feeWaiverFormGroupValue = this.getFeeWaiverFormGroupValue();

    return (
      feeWaiverFormGroupValue.feeWaiverCheckbox &&
      feeWaiverFormGroupValue.feeWaiverCause === FeeWaiverCause.Other
    );
  }

  handleFileInputAction(
    id: PlanningDepartmentDocTypeId,
    files: DocFile[],
  ): void {
    this.chosenFiles[id] = this.getFiles(id, files);
  }

  getFiles(id: PlanningDepartmentDocTypeId, files: DocFile[]): File[] {
    return files.map((file) => {
      file.docTypeId = id;

      return file;
    });
  }

  ngOnDestroy(): void {
    this.isAlive = false;
  }
}
